import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';

const QuickActions = ({ onNewScan }) => {
  const navigate = useNavigate();

  return (
    <div className="bg-card rounded-lg border border-border p-4">
      <div className="flex flex-col space-y-3">
        <Button
          variant="default"
          onClick={onNewScan}
          iconName="Clock"
          iconPosition="left"
          className="w-full"
        >
          Neuer Ende-Zeit Scan
        </Button>
        
        <Button
          variant="outline"
          onClick={() => navigate('/order-management-dashboard')}
          iconName="ClipboardList"
          iconPosition="left"
          className="w-full"
        >
          Zu Fahrten
        </Button>
      </div>
    </div>
  );
};

export default QuickActions;
